import { InvitesApi } from "@/api/invites";
import { User } from "@/types";
import { QueryKey } from "@/utils";
import { useQuery } from "@tanstack/react-query";

export const useGetUserInvites = (id: User["id"]) => {
  const { data, isError, isPending } = useQuery({
    queryKey: [QueryKey.INVITE, id],
    queryFn: () => InvitesApi.getFreeInvites({ userId: id }),
    enabled: !!id,
  });

  return {
    freeInvites: data?.count,
    freeInvitesError: isError,
    isUserInvitesLoading: isPending,
  };
};
